import { render, staticRenderFns } from "./instance.vue?vue&type=template&id=0463b488"
import script from "./instance.vue?vue&type=script&lang=js"
export * from "./instance.vue?vue&type=script&lang=js"
import style0 from "./instance.vue?vue&type=style&index=0&id=0463b488&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports